import type { TableColumnSize } from '@cli-types/core-engine/schema.js'
import { TABLE_COLUMN_SIZE_PRESETS } from '@cli-constants/generators.js'

export function getTableColumnSize(size: TableColumnSize | undefined): number {
  return TABLE_COLUMN_SIZE_PRESETS[size ?? 'default'] ?? TABLE_COLUMN_SIZE_PRESETS.default
}
